import { Directive, ElementRef } from '@angular/core';
import { clientCode as clientName } from '../../client';
import { StsCmsService } from '../../services/sts-cms-service.service';
import { StsConfigService } from '../../services/sts-config.service';
import { StsTenantService } from '../../services/sts-tenant.service';


@Directive({
  selector: '[app-sts-cms-image]',
  providers: [StsCmsService]
})
export class StsCmsImageDirective {

  constructor(el: ElementRef,
              private config: StsConfigService,
              private cmsService: StsCmsService,
              private tenantService: StsTenantService) {
    let def = el.nativeElement.getAttribute('default');
    let bypass = el.nativeElement.getAttribute('bypass');
    let b = (bypass ? bypass : '').toString().toLowerCase() === 'true';

    if (def) {
      def = def.replace(/\{#clientCode#}/gi, clientName);
      el.nativeElement.cssClass += 'dynamic-image';
      if (b) {
        el.nativeElement.src = def;
        el.nativeElement.alt = def;
      } else {

        this.tenantService.getTenantSource().subscribe(tenant => {

          let locale = tenant.currentLocale.toLowerCase();
          let clientCode = tenant.clientCode;

          // todo: confirm this is the standard client code for member
          let defaultMemberClientCode = 'ARIELHARMONYMEMBER';

          if ( clientCode && clientCode.toUpperCase() !== defaultMemberClientCode ) {
            // ex: def = "http://hooppemployer.dit.morneaushepell.com/tools/hoopp-sts-app/app/assets/images/logo.png";
            let leftPart = def.substring(0, def.lastIndexOf('.'));
            // ex: "http://hooppemployer.dit.morneaushepell.com/tools/hoopp-sts-app/app/assets/images/logo"
            let rightPart = def.substring(def.lastIndexOf('.')); // ex: ".png"
            def = leftPart + '-' + clientCode + rightPart;
          }

          if ( (locale !== 'en-us') && (locale !== 'en-ca') ) {
            // Required for cms localization
            let leftPart = def.substring(0, def.lastIndexOf('.'));
            let rightPart = def.substring(def.lastIndexOf('.'));
            def = leftPart + '-' + locale + rightPart;
          }

          cmsService.getImage(def).subscribe(
            a => {
              el.nativeElement.src = a ? a.src : def;
              el.nativeElement.alt = a ? a.name : def;
              el.nativeElement.cssClass += 'dynamic-image-loaded' ;
            },
            e => console.log(e)
          );
        });


      }
    }  else {
      console.log('>> invalid use of cms-image', el.nativeElement);
    }
  }


}
